import { render, staticRenderFns } from "./DocumentPOSindex.vue?vue&type=template&id=4659959a&scoped=true"
import script from "./DocumentPOSindex.vue?vue&type=script&lang=js"
export * from "./DocumentPOSindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4659959a",
  null
  
)

export default component.exports